import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { useContractContext } from 'common/Contract/ContractContext';

import { useRootContext } from '../../layout/RootContext';
import { SHOP_DATA_TABS_GENERAL_KEY } from '../constants';
import { getContractBenefitsMenuItems } from '../helpers';
import { SHOP_DATA_MODAL_GENERAL_SIDEBAR_MENU_ITEMS, SHOP_DATA_MODAL_LIVING_TYPE_SIDEBAR_MENU_ITEMS } from '../menus';
import { useShopDataModalContext } from '../ShopDataModalContext';
import { getSidebarMenuTestId } from '../testIdUtils';
import { ShopDataModalSidebarMenuItem } from '../types';

const Container = styled.div`
  border-right: 1px solid var(--line-gray);
  background: var(--background-gray-light);
  min-width: 250px;
  max-width: 250px;
`;

const MenuItem = styled.div`
  font-family: var(--font-bold);
  font-size: 14px;
  color: var(--text-primary);
  padding: 13px 30px 14px;
  cursor: pointer;
  user-select: none;

  &.active {
    color: var(--white);
    background: var(--active-blue);
  }

  &.disabled {
    pointer-events: none;
  }
`;

const MenuGroupLabel = styled.div`
  font-family: var(--font-bold);
  color: var(--text-secondary);
  padding: 20px 0 10px 30px;
`;

const ShopDataModalSidebar = () => {
  const { loading, form, currentTab, isCommunityCcrc, currentStep, community, setCurrentStep } =
    useShopDataModalContext();
  const { setSelectedKey, setKeys } = useContractContext();
  const { showMessage } = useRootContext();

  const items =
    currentTab === SHOP_DATA_TABS_GENERAL_KEY
      ? SHOP_DATA_MODAL_GENERAL_SIDEBAR_MENU_ITEMS
      : SHOP_DATA_MODAL_LIVING_TYPE_SIDEBAR_MENU_ITEMS;

  const uniqueCommunityContractsStepItems = getContractBenefitsMenuItems(community?.contracts ?? []);
  const showContractBenefits =
    isCommunityCcrc && currentTab === SHOP_DATA_TABS_GENERAL_KEY && uniqueCommunityContractsStepItems?.length > 0;

  const handleChange = async (step: number) => {
    await form
      ?.validateFields({ recursive: true })
      .then((response: any) => {
        form.submit();
        setCurrentStep(step);
        setSelectedKey(undefined);
        setKeys([]);
      })
      .catch((response: any) => {
        showMessage('info', 'Please complete you data entry.');
      });
  };

  return (
    <Container>
      <MenuGroupLabel>MAIN</MenuGroupLabel>
      {items?.map((item: ShopDataModalSidebarMenuItem) => (
        <MenuItem
          key={item.key}
          className={classNames({ active: item.step === currentStep, disabled: loading })}
          onClick={() => handleChange(item.step)}
          data-test-id={ getSidebarMenuTestId(item.label,'main')}
        >
          {item.label}
        </MenuItem>
      ))}
      {showContractBenefits && (
        <>
          <MenuGroupLabel>CONTRACT BENEFITS</MenuGroupLabel>
          {uniqueCommunityContractsStepItems?.map((item: ShopDataModalSidebarMenuItem) => (
            <MenuItem
              key={item.key}
              className={classNames({ active: item.step === currentStep, disabled: loading })}
              onClick={() => handleChange(item.step)}
              data-test-id={ getSidebarMenuTestId(item.label, 'contract-benefits')}
            >
              {item.label}
            </MenuItem>
          ))}
        </>
      )}
    </Container>
  );
};

export default ShopDataModalSidebar;
